import React, { useState } from 'react';
import { TextField, Button, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { translateError } from '../../utils/messages';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [isConfirming, setIsConfirming] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validatePassword = (password) => {
    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    
    if (!minLength) return 'パスワードは最低8文字必要です。';
    if (!hasLowercase) return 'パスワードには小文字（a〜z）を含めてください。';
    if (!hasNumber) return 'パスワードには数字（0〜9）を含めてください。';
    
    return '';
  };

  const handleSignUp = async () => {
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    
    try {
      await Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
          name: username, // ユーザー名を属性に追加
        },
      });
      setSuccess('確認コードを送信しました！メールを確認してください。');
      setError('');
      setIsConfirming(true); // 確認コード入力画面に切り替え
    } catch (error) {
      setError(translateError(error.message));
      setSuccess('');
    }
  };

  const handleConfirmSignUp = async () => {
    try {
      await Auth.confirmSignUp(email, confirmationCode);
      setSuccess('アカウントの確認が完了しました！サインインしてください。');
      setError('');
      setIsConfirming(false); // 完了後にリセットするかサインインページに遷移する
      // 2秒後にサインインページに遷移
      setTimeout(() => {
        history.push('/signin');
      }, 2000);
    } catch (error) {
      setError(translateError(error.message));
      setSuccess('');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', padding: 20 }}>
      <Typography variant="h5" gutterBottom>
        {isConfirming ? '確認コードの入力' : '新規登録'}
      </Typography>
      {!isConfirming ? (
        <>
          <TextField
            label="メールアドレス"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
          />
          <TextField
            label="パスワード"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
          />
          {error && (
            <Typography color="error" variant="body2" style={{ marginTop: 10 }}>
              {error}
            </Typography>
          )}
          <Button
          style={{
            backgroundColor: 'orange',
            color: 'white',
            marginTop: 20,
          }}
            variant="contained"
            fullWidth
            onClick={handleSignUp}
          >
            登録
          </Button>
        </>
      ) : (
        <>
          <TextField
            label="確認コード"
            type="text"
            fullWidth
            value={confirmationCode}
            onChange={(e) => setConfirmationCode(e.target.value)}
            margin="normal"
          />
          {error && (
            <Typography color="error" variant="body2" style={{ marginTop: 10 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="primary" variant="body2" style={{ marginTop: 10 }}>
              {success}
            </Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleConfirmSignUp}
            style={{ marginTop: 20 }}
          >
            確認コードを送信
          </Button>
        </>
      )}
      <Typography
      color="primary"
        style={{
          marginTop: 20,
          textAlign: 'center',
          cursor: 'pointer',
        }}
        onClick={() => (window.location.href = '/signin')}
      >
        サインインページに戻る
      </Typography>
    </div>
  );
};

export default RegisterPage;
